import { message, Spin } from 'antd';
import { GlobalContext } from 'context';
import { API, PATH } from 'data';
import { useContext } from 'react';
import { RestAPI, useAppNav, useAsyncClick } from 'scripts';
import styles from './topSection.module.scss';
import { __PostTopSectionPopsType } from './topSection.type';
import { TbHeart, TbHeartFilled } from 'react-icons/tb';

export default function PostTopSectionComp({ post, setPost }: __PostTopSectionPopsType) {
    const { profile } = useContext(GlobalContext);
    const appNav = useAppNav();
    const onLike = useAsyncClick(() => {
        return new Promise((resolve) => {
            if (!profile) {
                appNav.push(PATH.login(window.location.href));
                return;
            }
            if (!post.like_id) {
                // like the post
                RestAPI.post<{ id: number }>(API.like.add, { post: post.id })
                    .then((res) => {
                        setPost({ ...post, like_id: res.data.id });
                        resolve(true);
                    })
                    .catch(() => {
                        message.error('عملیات با خطا مواجه شد، لطفا بعدا دوباره امتحان کنید.');
                        resolve(true);
                    });
            } else
                RestAPI.delete(API.like.remove(post.like_id))
                    .then(() => {
                        setPost({ ...post, like_id: undefined });
                        resolve(true);
                    })
                    .catch(() => {
                        message.error('عملیات با خطا مواجه شد، لطفا بعدا دوباره امتحان کنید.');
                        resolve(true);
                    });
        });
    });

    return (
        <>
            <div className="center-content-y justify-content-between mb-3">
                {appNav.context}
                <h2 className={`t-h2 t-500 t-l-black1 t-d-gray3 ${styles['title']}`}>{post.title}</h2>
                <div className={`d-flex d-md-none ${styles['box-layout']} center-content-y`}>
                    {/* <div className={`w-100 center-content`}>
                        <TbEye className={'t-gray1'} size={18} />
                        <p className="t-p1 t-400 t-l-gray1">{post.views_count} بازدید</p>
                    </div> */}
                    <div
                        onClick={onLike.onClick}
                        className={`w-100 center-content pointer 
                                    ${onLike.loading ? styles['loading'] : ''}`}
                    >
                        {onLike.loading ? (
                            <div className={`center-content`}>
                                <Spin size="small" className="d-flex-i center-content" />
                            </div>
                        ) : post.like_id ? (
                            <TbHeartFilled className="t-red" size={18} />
                        ) : (
                            <TbHeart className="t-l-gray1 t-d-gray3" size={18} />
                        )}
                        {/* <p className={`t-p1 t-400 t-${post.like_id ? 'red' : 'gray1'}-i`}>
                            {post.like_id ? post.likes_count + 1 : post.likes_count} لایک
                        </p> */}
                    </div>
                </div>
            </div>
            <div className="center-content g-2 mb-3 d-pre-md-none">
                {/* <div className={`${styles['see']} ${styles['box']} w-100 center-content`}>
                    <TbEye className="t-gray1" size={18} />
                    <p className="t-p1 t-400 t-l-gray1">{post.views_count} بازدید</p>
                </div> */}
                <div
                    onClick={onLike.onClick}
                    className={`${styles['like']} ${post.like_id ? styles['isLike'] : styles['disLike']} ${styles['box']} 
                                w-100 center-content pointer ${onLike.loading ? styles['loading'] : ''}`}
                >
                    {onLike.loading ? (
                        <div className={`${styles['loading']} center-content`}>
                            <Spin size="small" className="d-flex-i center-content" />
                        </div>
                    ) : post.like_id ? (
                        <TbHeartFilled className="t-red" size={18} />
                    ) : (
                        <TbHeart className="t-l-gray1 t-d-gray3" size={18} />
                    )}
                    {/* <p className={`t-p1 t-400 t-${post.like_id ? 'red' : 'gray1'}-i`}>
                        {post.like_id ? post.likes_count + 1 : post.likes_count} لایک
                    </p> */}
                </div>
            </div>
        </>
    );
}
